import React from "react";

export default function SimpleBar({
  value,
  maxValue,
  color,
}: {
  value: number;
  maxValue: number;
  color: string;
}) {
  return (
    <div className="flex flex-align-center">
      <span className="fw-500" style={{ minWidth: "60px" }}>
        {value}
      </span>
      <div
        style={{
          height: "20px",
          width: `${(value / maxValue) * 100}%`,
          minWidth: "2px",
          backgroundColor: color,
        }}
      />
    </div>
  );
}
